interface StoryDetailsProps {
    createdAt?: string | null;
    updatedAt?: string | null;
}

const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const formatted = date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    });
    return formatted.replace(' AM', 'am').replace(' PM', 'pm');
};

export default function StoryDetails({ createdAt, updatedAt }: StoryDetailsProps) {
    return (
        <>
            <div className="mb-4">
                <h2 className="GraphikSemibold text-[18px] text-[#1f2328] mb-3">Story Details</h2>

                <div className="mb-3">
                    <h2 className='GraphikSemibold text-[14px] text-[#1f2328] mb-2'>Created</h2>
                    <p className='GraphikRegular text-[14px] text-[#1f2328]'>{createdAt ? formatDate(createdAt) : '—'}</p>
                </div>

                <div className="mb-3">
                    <h2 className='GraphikSemibold text-[14px] text-[#1f2328] mb-2'>Last Edited</h2>
                    <p className='GraphikRegular text-[14px] text-[#1f2328]'>{updatedAt ? formatDate(updatedAt) : '—'}</p>
                </div>

                <div className="mb-3">
                    <h2 className='GraphikSemibold text-[14px] text-[#1f2328] mb-2'>Published</h2>
                    <p className='GraphikRegular text-[14px] text-[#1f2328]'>{updatedAt ? formatDate(updatedAt) : '—'}</p>
                </div>
            </div>
        </>
    );
}
